import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface UserAnnouncementViewStatus {
  viewed: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class UserAnnouncementViewService {
  private readonly http = inject(HttpClient);

  hasViewed(
    announcementKey: string,
    businessAccountId: string,
  ): Observable<UserAnnouncementViewStatus> {
    const url = `${environment.shout_api.url}/user-announcement-views/${encodeURIComponent(announcementKey)}`;
    return this.http.get<UserAnnouncementViewStatus>(url, {
      params: { businessAccountId },
    });
  }

  markViewed(
    announcementKey: string,
    businessAccountId: string,
  ): Observable<UserAnnouncementViewStatus> {
    const url = `${environment.shout_api.url}/user-announcement-views/${encodeURIComponent(announcementKey)}`;
    return this.http.put<UserAnnouncementViewStatus>(url, { businessAccountId });
  }
}
